<script setup lang="ts">
interface Props {
  availableSortings: any
  search?: boolean
}
const { availableSortings, search } = defineProps<Props>()
const categoryStore = useCategoryStore()
const { path } = useRoute()
const open = ref(false)
const  load = () => {
  if (open.value) {
    open.value = false
  } else {
    open.value = true
  }
}
</script>

<template>
  <div class="relative">
    <div class="flex justify-end">
      <i class="icon-awesome-exchange-alt text-[20px] cursor-pointer" @click="load()" />
    </div>
    <div v-if="open" class="flex flex-col gap-[5px] absolute right-0 bg-white min-w-[250px] rounded-[5px] p-[15px] z-10">
      <div v-for="item in availableSortings" :key="item.key" class="text-14 cursor-pointer" @click="categoryStore.load({ type: 'order', key: item.key, path, search })">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
